import * as React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { ICartModel } from 'interfaces/ICartModel';
import UserForm from 'components/Cart/MainForm/UserForm';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import Translate from 'components/Translate';
import Grid from '@material-ui/core/Grid/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { paymentService } from 'services/PaymentService';

interface IState extends IStateBase {
  cart: ICartModel;
}

export default class Purchaser extends BaseComponent<IState> {
  public componentDidMount() {
    this.observeState({ cart: null }, paymentService.getCart());
  }

  public switchSamePerson = () => {
    const { cart } = this.state;

    const samePerson = !cart.samePerson;

    paymentService.setData({
      name: samePerson ? cart.studdent.name : '',
      email: samePerson ? cart.studdent.email : '',
      document: samePerson ? cart.studdent.document : '',
      phone: samePerson ? cart.studdent.phone : '',
      samePerson
    });
  };

  render() {
    if (!this.state || !this.state.cart) {
      return null;
    }

    const { samePerson } = this.state.cart;

    return (
      <React.Fragment>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  id={'chk-sameperson'}
                  className="checkbox"
                  value="1"
                  checked={!!samePerson}
                  onChange={this.switchSamePerson}
                />
              }
              label={<Translate term="Sou aluno e responsável financeiro" />}
            />
          </Grid>
          {!samePerson && <UserForm />}
        </Grid>
      </React.Fragment>
    );
  }
}
